
import jQuery from 'jquery';
import Isotope from 'isotope-layout';
/// Don't think we need this - the filtering / viewing happens in the ui + not really filtering - just more more categorising the post nows


export function categoryFilters($filter, initiator) {
  
var  $ = $ || jQuery; // added to see solve jquery issue

    // console.log("categoryFilters");
    console.log("DO WE EVEN USE? - delete fucntions /file categoryFilters", $filter);
    console.log("intiator", initiator);


      /*
      We need to make sure that this function considers all the eventualities and locations that it maybe tbe displayed on the website
    - single wirtting - read more
    - archive writting
    - home page
      */
 

      var $grid = $filter.find('.related__items'),
      grid = $grid[0];
    // filter = $filter[0];
// // filters
//    const filter = filter.querySelector('#filters');

//   filter.addEventListener('click', function (e) {
//     relate.isotope({ filter: '*' })

//   var elem = document.querySelector('.related__items');
//   var iso = new Isotope( elem, {
//     // options
//     itemSelector: '.related__item',
//     layoutMode: 'fitRows'
//   });


// external js: isotope.pkgd.js

// init Isotope
var iso = new Isotope( grid, {
  itemSelector: '.related__item',
  layoutMode: 'fitRows',
//   /* default
// hiddenStyle: {
//   opacity: 0,
//   transform: 'scale(0.001)'
// },
// visibleStyle: {
//   opacity: 1,
//   transform: 'scale(1)'
// }
// */
hiddenStyle: {
  opacity: 0
  // transform: 'scale(0.001)'
},
visibleStyle: {
  opacity: 1
  // transform: 'scale(1)'
}
});


//review the use of these- not used atm

// filter functions
var filterFns = {
  // show if number is greater than 50
  numberGreaterThan50: function( itemElem ) {
    var number = itemElem.querySelector('.number').textContent;
    return parseInt( number, 10 ) > 50;
  },
  // show if name ends with -ium
  ium: function( itemElem ) {
    var name = itemElem.querySelector('.name').textContent;
    return name.match( /ium$/ );
  }
};

// bind filter button click
// var filtersElem = filter;
var filtersElem = document.querySelectorAll('.filter-item');


console.log("filtersElem", filtersElem);

// change is-active class on buttons
// var buttonGroups = $filter[0].querySelector('.post-filter');
var buttonGroups = filtersElem;

console.log("buttonGroups", buttonGroups);
console.log("buttonGroups; lenght", buttonGroups.length);


filtersElem.forEach((item) => {


item.addEventListener( 'click', function( event ) {
  // only work with buttons
  // if ( !matchesSelector( event.target, 'button' ) ) {
  //   return;
  // }

//   if(!event.target.tagName.toLowerCase() === 'button')
// {
//     // event.target.href; //this is the url where the anchor tag points to.

// console.log("should return");
// return;
//   }

// there is an issue with this function if the user clicks on the parent
// and not the buttons - the above matchesSelecter is not working

  console.log("filtersElem", event.target.getAttribute('data-filter-data'));

  var filterValue = event.target.getAttribute('data-filter-data');
  // use matching filter function
  filterValue = filterFns[ filterValue ] || filterValue;
  iso.arrange({ filter: filterValue });


  document.querySelector('.is-active').classList.remove('is-active');
    event.target.classList.add('is-active');
  console.log("active classes changed")
});

});


// for ( var i=0, len = buttonGroups.length; i < len; i++ ) {
//   var buttonGroup = buttonGroups[i];

//   console.log("buttonGroup", buttonGroup);

//   radioButtonGroup( buttonGroup );
// }

// function radioButtonGroup( buttonGroup ) {

//   console.log("function radioButtonGroup", buttonGroup);

//   buttonGroup.addEventListener( 'click', function( event ) {

//     console.log("buttonGroup", event.target);
//     // only work with buttons
//     // if ( !matchesSelector( event.target, 'button' ) ) {
//     //   return;
//     // }
//     buttonGroup.querySelector('.is-active').classList.remove('is-active');
//     event.target.classList.add('is-active');
//   });
// }


}